var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNetworkIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.169 12.442C11.826 11.778 13 10.164 13 8.27002C13 5.78502 10.985 3.77002 8.5 3.77002C6.015 3.77002 4 5.78502 4 8.27002C4 10.164 5.174 11.778 6.831 12.442",
    stroke: "#6A82D2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M11.284 15.23C14.046 14.124 16 11.427 16 8.27002C16 4.12802 12.642 0.77002 8.5 0.77002C4.358 0.77002 1 4.12802 1 8.27002C1 11.427 2.954 14.124 5.716 15.23",
    stroke: "#454C58",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M8.5 9.77002C9.32843 9.77002 10 9.09845 10 8.27002C10 7.44159 9.32843 6.77002 8.5 6.77002C7.67157 6.77002 7 7.44159 7 8.27002C7 9.09845 7.67157 9.77002 8.5 9.77002Z",
    stroke: "#454C58",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNetworkIcon);
export default __webpack_public_path__ + "static/media/Network-Icon.f17dadda7de4884c7e0d9f7970bd75a4.svg";
export { ForwardRef as ReactComponent };